import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { CircularProgressBar } from "./ui/circular-progress-bar";

interface BulkActionsProgressDialogProps {
  isOpen: boolean;
  onClose: () => void;
  progress: number;
  message: React.ReactNode;
  title: string;
}

export const BulkActionsProgressDialog: React.FC<BulkActionsProgressDialogProps> = ({
  isOpen,
  onClose,
  progress,
  message,
  title,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4">
          <CircularProgressBar progress={progress} />
          <p>{message}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
